var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g2, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _g3, _path51, _path52, _path53, _g4, _path54, _path55, _path56, _g5, _path57, _path58, _path59, _g6, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscoverability(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 643,
    height: 451,
    viewBox: "0 0 643 451",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M575.137 192H472.31C466.097 192 461.06 197.037 461.06 203.25V425.332C461.06 431.545 466.097 436.582 472.31 436.582H575.137C581.351 436.582 586.388 431.545 586.388 425.332V203.25C586.388 197.037 581.351 192 575.137 192Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_120_9594",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 461,
    y: 192,
    width: 126,
    height: 245
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M575.137 192H472.31C466.097 192 461.06 197.037 461.06 203.25V425.332C461.06 431.545 466.097 436.582 472.31 436.582H575.137C581.351 436.582 586.388 431.545 586.388 425.332V203.25C586.388 197.037 581.351 192 575.137 192Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_120_9594)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M471.845 192C468.98 192 466.233 193.138 464.208 195.164C462.182 197.189 461.044 199.936 461.044 202.801V425.781C461.042 427.361 461.389 428.923 462.058 430.354C462.728 431.786 463.704 433.052 464.918 434.064L538.039 192H471.845Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.989 429.508C527.989 428.665 527.739 427.841 527.271 427.14C526.802 426.439 526.137 425.893 525.358 425.57C524.58 425.248 523.723 425.164 522.896 425.328C522.069 425.492 521.31 425.898 520.714 426.494C520.118 427.09 519.712 427.85 519.548 428.676C519.383 429.503 519.468 430.36 519.79 431.138C520.113 431.917 520.659 432.583 521.36 433.051C522.061 433.519 522.885 433.769 523.727 433.769C524.858 433.769 525.942 433.32 526.741 432.521C527.54 431.722 527.989 430.638 527.989 429.508Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M575.137 192H472.31C466.097 192 461.06 197.037 461.06 203.25V425.332C461.06 431.545 466.097 436.582 472.31 436.582H575.137C581.351 436.582 586.388 431.545 586.388 425.332V203.25C586.388 197.037 581.351 192 575.137 192Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M580.825 208.613H466.639V422.07H580.825V208.613Z",
    fill: "#ECEBFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_120_9594",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 466,
    y: 208,
    width: 115,
    height: 215
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M580.825 208.613H466.639V422.07H580.825V208.613Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_120_9594)"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M559.401 313.942L541.301 297.586L523.728 297.888L506.154 297.586L488.054 313.942L445.253 342.131V425.301H521.465H525.99H602.202V342.131L559.401 313.942Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.01,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M522.263 375.472L514.461 386.537C514.461 386.537 523.759 382.321 532.716 378.672C541.673 375.023 552.931 363.509 555.457 359.301C557.983 355.094 561.656 348.911 561.656 348.911L550.405 340.241H562.5C562.5 340.241 562.214 327.068 558.564 316.368",
    stroke: "#263238",
    strokeWidth: 1.01,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M518.699 380.307C517.39 379.757 516.065 379.207 514.74 378.672C505.76 375.023 494.525 363.509 491.999 359.301C489.473 355.094 485.8 348.911 485.8 348.911L497.058 340.241H485.018C485.018 340.241 485.304 327.068 488.954 316.368",
    stroke: "#263238",
    strokeWidth: 1.01,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M504.597 298.826C504.597 298.826 501.103 354.311 522.263 375.472C522.263 375.472 544.586 360.146 544.586 299.492L504.597 298.826Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_120_9594",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 504,
    y: 298,
    width: 41,
    height: 78
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M504.597 298.826C504.597 298.826 501.103 354.311 522.263 375.472C522.263 375.472 544.586 360.146 544.586 299.492L504.597 298.826Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_120_9594)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M516.413 235.685H534.412C539.573 235.685 544.521 237.735 548.17 241.383C551.819 245.032 553.868 249.981 553.868 255.141V295.517C553.869 298.947 553.195 302.344 551.883 305.513C550.571 308.683 548.648 311.562 546.224 313.989C543.799 316.415 540.92 318.34 537.752 319.653C534.583 320.967 531.187 321.643 527.757 321.644H523.108C519.678 321.644 516.281 320.969 513.112 319.656C509.943 318.343 507.064 316.419 504.638 313.994C502.213 311.569 500.289 308.689 498.977 305.52C497.664 302.351 496.988 298.955 496.988 295.525V255.141C496.988 249.981 499.038 245.032 502.687 241.383C506.335 237.735 511.284 235.685 516.444 235.685H516.413Z",
    fill: "#ECEBFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M516.413 235.685H534.412C539.573 235.685 544.521 237.735 548.17 241.383C551.819 245.032 553.868 249.981 553.868 255.141V295.517C553.869 298.947 553.195 302.344 551.883 305.513C550.571 308.683 548.648 311.562 546.224 313.989C543.799 316.415 540.92 318.34 537.752 319.653C534.583 320.967 531.187 321.643 527.757 321.644H523.108C519.678 321.644 516.281 320.969 513.112 319.656C509.943 318.343 507.064 316.419 504.638 313.994C502.213 311.569 500.289 308.689 498.977 305.52C497.664 302.351 496.988 298.955 496.988 295.525V255.141C496.988 249.981 499.038 245.032 502.687 241.383C506.335 237.735 511.284 235.685 516.444 235.685H516.413Z",
    fill: "white"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M504.597 298.826C504.597 298.826 501.103 354.311 522.263 375.472C522.263 375.472 544.586 360.146 544.586 299.492L504.597 298.826Z",
    stroke: "#263238",
    strokeWidth: 1.01,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M513.5 294.099C513.5 294.099 511.563 318.313 523.255 327.549C523.255 327.549 535.59 320.862 535.59 294.394L513.5 294.099Z",
    stroke: "#263238",
    strokeWidth: 1.01,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M509.595 335.15L523.255 327.549L538.589 338.148",
    stroke: "#263238",
    strokeWidth: 1.01,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M526.928 339.814L529.593 332.151L523.255 327.549L514.926 332.151L519.257 339.125L512.423 359.65C514.887 365.786 518.095 371.272 522.263 375.449C522.263 375.449 528.198 371.373 533.948 359.107L526.928 339.814Z",
    fill: "#908DC1",
    stroke: "#263238",
    strokeWidth: 1.01,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M554.232 381.65C560.301 380.66 564.419 374.938 563.429 368.869C562.44 362.8 556.718 358.682 550.648 359.671C544.579 360.661 540.461 366.383 541.451 372.452C542.44 378.521 548.163 382.639 554.232 381.65Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.01,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M559.831 373.699C561.512 369.61 559.561 364.934 555.472 363.253C551.384 361.572 546.707 363.523 545.026 367.612C543.345 371.7 545.297 376.377 549.385 378.058C553.474 379.739 558.15 377.787 559.831 373.699Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.01,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M552.427 372.365C551.975 372.365 551.542 372.185 551.222 371.865C550.902 371.546 550.723 371.112 550.723 370.66V305.241C550.723 304.789 550.902 304.356 551.222 304.036C551.542 303.716 551.975 303.537 552.427 303.537C552.879 303.537 553.313 303.716 553.633 304.036C553.952 304.356 554.132 304.789 554.132 305.241V370.66C554.133 370.884 554.09 371.106 554.004 371.313C553.919 371.521 553.793 371.709 553.635 371.868C553.476 372.026 553.288 372.152 553.081 372.237C552.874 372.322 552.651 372.366 552.427 372.365Z",
    fill: "#263238"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M498.631 396.09H498.468C496.919 395.826 482.05 381.368 480.647 377.494C479.245 373.62 479.64 367.421 479.656 367.189C479.67 366.963 479.774 366.752 479.944 366.602C480.114 366.452 480.336 366.376 480.562 366.391C480.788 366.405 480.999 366.509 481.149 366.679C481.299 366.849 481.375 367.071 481.36 367.297C481.36 367.351 481.012 373.38 482.251 376.936C483.39 380.183 496.624 393.146 498.716 394.408C499.879 394.044 504.14 390.224 505.69 386.312C505.731 386.207 505.792 386.112 505.87 386.031C505.948 385.951 506.041 385.886 506.144 385.842C506.247 385.797 506.358 385.773 506.47 385.771C506.582 385.77 506.694 385.79 506.798 385.831C506.902 385.872 506.997 385.934 507.078 386.012C507.158 386.09 507.223 386.183 507.268 386.286C507.312 386.389 507.336 386.499 507.338 386.611C507.34 386.723 507.319 386.835 507.278 386.939C505.667 391.084 500.591 396.09 498.631 396.09Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.01,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M485.42 396.09C483.452 396.09 478.385 391.084 476.742 386.893C476.659 386.682 476.663 386.447 476.753 386.239C476.843 386.031 477.012 385.868 477.223 385.785C477.433 385.701 477.668 385.705 477.876 385.795C478.084 385.885 478.248 386.054 478.331 386.265C479.88 390.178 484.134 394.013 485.304 394.362C487.396 393.099 500.63 380.136 501.769 376.89C503.009 373.333 502.668 367.305 502.66 367.251C502.646 367.025 502.722 366.802 502.872 366.632C503.021 366.462 503.232 366.359 503.458 366.344C503.684 366.33 503.907 366.406 504.077 366.556C504.247 366.705 504.351 366.916 504.365 367.142C504.365 367.406 504.737 373.573 503.373 377.448C502.01 381.322 487.172 395.811 485.552 396.043L485.42 396.09Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.01,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M492.231 338.265C491.78 338.262 491.347 338.082 491.028 337.763C490.709 337.444 490.528 337.011 490.526 336.56V308.023C490.526 307.571 490.706 307.137 491.026 306.818C491.345 306.498 491.779 306.318 492.231 306.318C492.683 306.318 493.117 306.498 493.436 306.818C493.756 307.137 493.936 307.571 493.936 308.023V336.56C493.936 336.784 493.892 337.005 493.806 337.212C493.72 337.419 493.595 337.607 493.436 337.765C493.278 337.924 493.09 338.049 492.883 338.135C492.677 338.22 492.455 338.265 492.231 338.265Z",
    fill: "#263238"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M503.366 370.629C502.914 370.627 502.482 370.447 502.163 370.128C501.844 369.808 501.663 369.376 501.661 368.925V348.392C501.661 345.798 500.631 343.311 498.797 341.477C496.963 339.644 494.476 338.613 491.883 338.613C489.29 338.613 486.802 339.644 484.969 341.477C483.135 343.311 482.105 345.798 482.105 348.392V368.909C482.105 369.361 481.925 369.795 481.605 370.114C481.286 370.434 480.852 370.614 480.4 370.614C479.948 370.614 479.514 370.434 479.195 370.114C478.875 369.795 478.695 369.361 478.695 368.909V348.376C478.695 344.883 480.083 341.532 482.553 339.062C485.024 336.592 488.374 335.204 491.867 335.204C495.361 335.204 498.711 336.592 501.181 339.062C503.652 341.532 505.039 344.883 505.039 348.376V368.909C505.042 369.358 504.867 369.79 504.554 370.111C504.241 370.433 503.815 370.619 503.366 370.629Z",
    fill: "#263238"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M475.168 383.719L474.88 383.942C474.015 384.614 473.858 385.86 474.53 386.725L475.79 388.347C476.462 389.212 477.708 389.369 478.573 388.697L478.861 388.473C479.726 387.801 479.882 386.555 479.21 385.69L477.951 384.068C477.279 383.203 476.033 383.047 475.168 383.719Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.01,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M504.891 388.464L505.179 388.687C506.044 389.359 507.29 389.202 507.962 388.337L509.222 386.716C509.894 385.851 509.737 384.604 508.872 383.932L508.584 383.709C507.719 383.037 506.473 383.194 505.801 384.059L504.541 385.68C503.869 386.545 504.026 387.791 504.891 388.464Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.01,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M495.485 262.967H494.764C492.531 262.967 490.72 264.778 490.72 267.012V274.272C490.72 276.505 492.531 278.316 494.764 278.316H495.485C497.719 278.316 499.53 276.505 499.53 274.272V267.012C499.53 264.778 497.719 262.967 495.485 262.967Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.01,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M555.023 262.967H554.302C552.069 262.967 550.258 264.778 550.258 267.012V274.272C550.258 276.505 552.069 278.316 554.302 278.316H555.023C557.257 278.316 559.068 276.505 559.068 274.272V267.012C559.068 264.778 557.257 262.967 555.023 262.967Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.01,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M516.413 224.512H534.412C539.572 224.512 544.521 226.562 548.17 230.21C551.819 233.859 553.868 238.808 553.868 243.968V284.344C553.868 291.271 551.116 297.915 546.218 302.813C541.32 307.712 534.676 310.463 527.749 310.463H523.1C519.67 310.463 516.273 309.788 513.104 308.475C509.935 307.163 507.056 305.239 504.631 302.813C502.205 300.388 500.281 297.508 498.969 294.339C497.656 291.17 496.98 287.774 496.98 284.344V243.968C496.98 238.812 499.027 233.866 502.671 230.218C506.314 226.57 511.257 224.518 516.413 224.512Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.01,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M518.722 258.488H509.75C508.941 258.488 508.285 259.144 508.285 259.953V260.216C508.285 261.025 508.941 261.681 509.75 261.681H518.722C519.531 261.681 520.187 261.025 520.187 260.216V259.953C520.187 259.144 519.531 258.488 518.722 258.488Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.01,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M542.239 258.488H533.266C532.457 258.488 531.802 259.144 531.802 259.953V260.216C531.802 261.025 532.457 261.681 533.266 261.681H542.239C543.047 261.681 543.703 261.025 543.703 260.216V259.953C543.703 259.144 543.047 258.488 542.239 258.488Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.01,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M517.561 268.22C517.561 270.064 516.716 271.552 515.67 271.552C514.624 271.552 513.787 270.064 513.787 268.22C513.787 266.376 514.632 264.881 515.67 264.881C516.708 264.881 517.561 266.376 517.561 268.22Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.01,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M538.774 268.22C538.774 270.064 537.93 271.552 536.884 271.552C535.838 271.552 534.993 270.064 534.993 268.22C534.993 266.376 535.838 264.881 536.884 264.881C537.93 264.881 538.774 266.376 538.774 268.22Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.01,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M535.59 224.512H515.235C510.388 224.512 505.738 226.437 502.311 229.865C498.883 233.293 496.957 237.942 496.957 242.79V285.739C496.957 292.296 499.562 298.585 504.199 303.222C508.836 307.859 515.124 310.463 521.682 310.463H529.182C532.429 310.464 535.645 309.826 538.645 308.583C541.645 307.341 544.371 305.52 546.667 303.224C548.964 300.928 550.785 298.202 552.027 295.202C553.269 292.201 553.908 288.986 553.907 285.739V242.79C553.907 240.386 553.433 238.006 552.512 235.786C551.591 233.566 550.241 231.549 548.54 229.852C546.838 228.154 544.819 226.808 542.597 225.892C540.375 224.976 537.994 224.507 535.59 224.512ZM549.537 279.687C549.537 279.687 549.537 284.91 544.315 290.14C544.315 290.14 538.798 282.88 536.473 282.298C534.97 281.927 529.376 282.035 525.579 282.159C521.79 282.035 516.188 281.927 514.732 282.298C512.407 282.88 506.89 290.14 506.89 290.14C501.668 284.91 501.668 279.687 501.668 279.687V255.877L504.388 252.297C505.428 250.966 506.024 249.343 506.092 247.655C506.16 245.967 505.697 244.301 504.767 242.891C503.79 241.393 503.365 239.602 503.564 237.825C503.764 236.048 504.575 234.395 505.86 233.151L505.914 233.105C507.158 231.901 508.771 231.152 510.493 230.978C512.215 230.803 513.946 231.214 515.406 232.144L519.466 235.328C521.236 236.711 523.418 237.461 525.664 237.461C527.911 237.461 530.092 236.711 531.863 235.328L535.908 232.144C537.375 231.209 539.115 230.795 540.847 230.969C542.579 231.143 544.201 231.896 545.454 233.105L545.5 233.151C546.786 234.419 547.591 236.095 547.778 237.892C547.965 239.688 547.521 241.494 546.523 242.999C545.625 244.405 545.187 246.055 545.269 247.721C545.351 249.387 545.949 250.986 546.98 252.297L549.793 255.877L549.537 279.687Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.01,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M529.771 278.696C529.771 278.696 533.258 278.231 533.258 280.246C533.258 282.26 531.22 283.725 527.16 282.276",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M529.771 278.696C529.771 278.696 533.258 278.231 533.258 280.246C533.258 282.26 531.22 283.725 527.16 282.276",
    stroke: "#263238",
    strokeWidth: 1.01,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M529.477 262.262V279.106C529.477 280.03 529.11 280.916 528.458 281.569C527.806 282.223 526.921 282.591 525.998 282.593H522.898C520.682 282.748 519.907 282.206 519.644 281.268C519.562 280.956 519.546 280.63 519.596 280.311C519.647 279.992 519.763 279.688 519.938 279.416C519.938 278.549 523.642 278.549 523.642 278.549",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M529.477 262.262V279.106C529.477 280.03 529.11 280.916 528.458 281.569C527.806 282.223 526.921 282.591 525.998 282.593H522.898C520.682 282.748 519.907 282.206 519.644 281.268C519.562 280.956 519.546 280.63 519.596 280.311C519.647 279.992 519.763 279.688 519.938 279.416C519.938 278.549 523.642 278.549 523.642 278.549",
    stroke: "#263238",
    strokeWidth: 1.01,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M525.827 292.201C522.593 292.219 519.411 291.389 516.599 289.792C516.322 289.606 516.129 289.32 516.06 288.995C515.991 288.669 516.052 288.329 516.229 288.048C516.407 287.766 516.688 287.565 517.011 287.487C517.335 287.409 517.676 287.46 517.963 287.63C520.398 288.96 523.132 289.651 525.907 289.638C528.682 289.624 531.409 288.907 533.831 287.552C533.98 287.465 534.145 287.409 534.316 287.386C534.487 287.364 534.66 287.377 534.826 287.424C534.992 287.471 535.147 287.551 535.281 287.659C535.416 287.767 535.527 287.901 535.608 288.053C535.689 288.206 535.738 288.373 535.753 288.544C535.768 288.716 535.748 288.889 535.694 289.053C535.64 289.217 535.554 289.368 535.44 289.498C535.326 289.627 535.188 289.733 535.032 289.807C532.21 291.358 529.047 292.181 525.827 292.201Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.01,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M535.156 273.256H540.781",
    stroke: "#263238",
    strokeWidth: 1.01,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M512.811 273.256H518.436",
    stroke: "#263238",
    strokeWidth: 1.01,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M490.526 417.134C496.08 417.134 500.583 412.632 500.583 407.077C500.583 401.523 496.08 397.02 490.526 397.02C484.972 397.02 480.469 401.523 480.469 407.077C480.469 412.632 484.972 417.134 490.526 417.134Z",
    stroke: "#263238",
    strokeWidth: 0.724166,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M490.511 409.564C489.973 409.564 489.457 409.35 489.076 408.97C488.695 408.589 488.481 408.073 488.481 407.534V401.103C488.481 400.565 488.695 400.048 489.076 399.668C489.457 399.287 489.973 399.073 490.511 399.073C491.05 399.073 491.566 399.287 491.947 399.668C492.328 400.048 492.542 400.565 492.542 401.103V407.534C492.542 408.073 492.328 408.589 491.947 408.97C491.566 409.35 491.05 409.564 490.511 409.564Z",
    fill: "#263238"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M490.526 411.028C489.575 411.026 488.664 410.648 487.991 409.975C487.319 409.303 486.941 408.392 486.938 407.441V404.419C486.938 404.321 486.978 404.226 487.047 404.156C487.117 404.086 487.212 404.047 487.31 404.047C487.36 404.046 487.408 404.055 487.454 404.073C487.5 404.092 487.541 404.119 487.576 404.154C487.61 404.189 487.638 404.23 487.656 404.276C487.674 404.321 487.683 404.37 487.682 404.419V407.441C487.72 408.171 488.037 408.858 488.567 409.361C489.097 409.863 489.799 410.144 490.53 410.144C491.26 410.144 491.963 409.863 492.493 409.361C493.023 408.858 493.339 408.171 493.377 407.441V404.419C493.376 404.37 493.385 404.321 493.403 404.276C493.422 404.23 493.449 404.189 493.484 404.154C493.519 404.119 493.56 404.092 493.606 404.073C493.651 404.055 493.7 404.046 493.749 404.047C493.848 404.047 493.942 404.086 494.012 404.156C494.082 404.226 494.121 404.321 494.121 404.419V407.441C494.119 408.393 493.739 409.306 493.065 409.978C492.391 410.651 491.478 411.028 490.526 411.028Z",
    fill: "#263238"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M490.526 414.887C490.478 414.887 490.43 414.877 490.385 414.859C490.34 414.84 490.3 414.812 490.266 414.778C490.232 414.743 490.205 414.702 490.188 414.657C490.17 414.612 490.161 414.564 490.162 414.515V410.641C490.162 410.538 490.203 410.44 490.276 410.367C490.348 410.294 490.447 410.254 490.55 410.254C490.652 410.254 490.751 410.294 490.824 410.367C490.896 410.44 490.937 410.538 490.937 410.641V414.515C490.939 414.568 490.929 414.62 490.908 414.669C490.887 414.717 490.857 414.761 490.817 414.796C490.778 414.831 490.732 414.858 490.682 414.873C490.632 414.889 490.579 414.894 490.526 414.887Z",
    fill: "#263238"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M493.006 415.089H488.055C487.957 415.087 487.863 415.047 487.794 414.978C487.724 414.909 487.685 414.815 487.683 414.717C487.683 414.619 487.722 414.524 487.792 414.454C487.861 414.385 487.956 414.345 488.055 414.345H493.006C493.104 414.345 493.199 414.385 493.269 414.454C493.338 414.524 493.378 414.619 493.378 414.717C493.376 414.815 493.336 414.909 493.266 414.978C493.197 415.047 493.104 415.087 493.006 415.089Z",
    fill: "#263238"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M557.123 417.134C562.677 417.134 567.18 412.632 567.18 407.077C567.18 401.523 562.677 397.02 557.123 397.02C551.568 397.02 547.065 401.523 547.065 407.077C547.065 412.632 551.568 417.134 557.123 417.134Z",
    stroke: "#263238",
    strokeWidth: 0.724166,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M523.829 417.134C529.383 417.134 533.886 412.632 533.886 407.077C533.886 401.523 529.383 397.02 523.829 397.02C518.274 397.02 513.771 401.523 513.771 407.077C513.771 412.632 518.274 417.134 523.829 417.134Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.724166,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M528.919 404.954H518.738C518.456 404.954 518.177 405.016 517.922 405.135C517.667 405.255 517.441 405.429 517.26 405.646C517.08 405.862 516.949 406.116 516.878 406.389C516.807 406.662 516.796 406.947 516.847 407.224L517.142 408.82C517.163 408.928 517.221 409.026 517.306 409.096C517.39 409.167 517.496 409.206 517.607 409.208H520.706C520.833 409.208 520.956 409.157 521.046 409.067C521.136 408.977 521.186 408.855 521.186 408.727V406.999H526.533V408.727C526.533 408.855 526.583 408.977 526.673 409.067C526.763 409.157 526.886 409.208 527.013 409.208H530.112C530.224 409.208 530.332 409.169 530.418 409.099C530.504 409.028 530.563 408.93 530.585 408.82L530.879 407.224C530.932 406.941 530.92 406.65 530.845 406.372C530.769 406.094 530.633 405.836 530.444 405.618C530.256 405.4 530.021 405.227 529.757 405.112C529.493 404.997 529.207 404.943 528.919 404.954Z",
    fill: "#ECEBFF"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M580.825 208.613H466.639V422.07H580.825V208.613Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M374.927 152.274H226.421V429.888H374.927V152.274Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M367.529 130.669H233.796C225.715 130.669 219.164 137.22 219.164 145.301V434.13C219.164 442.211 225.715 448.762 233.796 448.762H367.529C375.61 448.762 382.161 442.211 382.161 434.13V145.301C382.161 137.22 375.61 130.669 367.529 130.669Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_120_9594",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 219,
    y: 130,
    width: 164,
    height: 319
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M367.529 130.669H233.796C225.715 130.669 219.164 137.22 219.164 145.301V434.13C219.164 442.211 225.715 448.762 233.796 448.762H367.529C375.61 448.762 382.161 442.211 382.161 434.13V145.301C382.161 137.22 375.61 130.669 367.529 130.669Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_120_9594)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M233.192 130.669C229.466 130.669 225.893 132.149 223.259 134.783C220.625 137.418 219.145 140.991 219.145 144.717V434.715C219.143 436.77 219.593 438.8 220.464 440.662C221.335 442.524 222.604 444.171 224.183 445.487L319.28 130.669H233.192Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.21 439.562C306.21 438.466 305.885 437.394 305.276 436.483C304.667 435.571 303.801 434.861 302.788 434.441C301.776 434.022 300.661 433.912 299.586 434.126C298.511 434.34 297.523 434.868 296.748 435.643C295.973 436.418 295.445 437.406 295.231 438.481C295.018 439.556 295.127 440.67 295.547 441.683C295.966 442.696 296.677 443.561 297.588 444.17C298.5 444.779 299.571 445.104 300.667 445.104C302.137 445.104 303.547 444.52 304.586 443.481C305.626 442.442 306.21 441.032 306.21 439.562Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M367.529 130.669H233.796C225.715 130.669 219.164 137.22 219.164 145.301V434.13C219.164 442.211 225.715 448.762 233.796 448.762H367.529C375.61 448.762 382.161 442.211 382.161 434.13V145.301C382.161 137.22 375.61 130.669 367.529 130.669Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M374.927 152.274H226.421V429.888H374.927V152.274Z",
    fill: "#ECEBFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_120_9594",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 213,
    y: 117,
    width: 178,
    height: 313
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M390.52 117.433H213.592V429.888H390.52V117.433Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_120_9594)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324.052 221.059C324.364 221.527 333.789 223.409 338.678 230.517C341.523 234.6 343.909 238.985 345.794 243.59C345.794 243.59 353.97 248.455 358.161 252.465C362.352 256.475 367.348 261.799 371.201 264.593C375.055 267.387 382.985 272.687 384.981 278.891C384.981 278.891 373.091 311.456 369.73 318.654C366.37 325.852 358.079 341.128 358.079 341.128L343.288 433.964H257.493L254.568 382.41C254.568 382.41 228.273 377.25 217.286 367.62C217.286 367.62 216.251 343.79 220.845 322.532C225.438 301.275 241.059 257.075 251.642 243.574C251.642 243.574 268.545 235.488 283.459 232.892C283.459 232.892 293.139 225.242 299.474 224.428C305.81 223.615 324.052 221.059 324.052 221.059Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.726 392.125C263.343 393.58 269.983 394.837 277.74 394.747C285.497 394.656 293.418 392.914 299.762 388.469C300.987 387.449 302.376 386.643 303.87 386.086C307.239 385.141 310.575 387.368 313.92 388.403C318.16 389.718 322.811 389.093 326.968 387.516C331.126 385.938 334.865 383.481 338.571 381.032C338.023 388.592 337.845 396.165 338.037 403.753L343.32 403.966L356.854 344.417C356.854 344.417 333.706 371.303 322.424 379.331L300.78 373.76C300.78 373.76 298.743 375.453 294.453 376.307C294.453 376.307 292.489 383.859 281.446 383.875C270.402 383.892 254.567 382.413 254.567 382.413L255.726 392.125Z",
    fill: "#908DC1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M255.726 392.125C263.343 393.58 269.983 394.837 277.74 394.747C285.497 394.656 293.418 392.914 299.762 388.469C300.987 387.449 302.376 386.643 303.87 386.086C307.239 385.141 310.575 387.368 313.92 388.403C318.16 389.718 322.811 389.093 326.968 387.516C331.126 385.938 334.865 383.481 338.571 381.032C338.023 388.592 337.845 396.165 338.037 403.753L343.32 403.966L356.854 344.417C356.854 344.417 333.706 371.303 322.424 379.331L300.78 373.76C300.78 373.76 298.743 375.453 294.453 376.307C294.453 376.307 292.489 383.859 281.446 383.875C270.402 383.892 254.567 382.413 254.567 382.413L255.726 392.125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.549 281.011C233.549 281.011 223.5 329.796 224.009 346.551C224.009 346.551 237.666 342.722 247.198 346.551C247.198 346.551 230.977 344.743 223.993 352.179C217.008 359.616 238.504 379.156 281.513 375.187C281.513 375.187 290.091 377.874 294.446 376.297C294.446 376.297 293.28 384.07 281.439 383.865C269.647 383.396 235.152 383.109 217.28 367.628C217.288 367.636 215.036 322.787 233.549 281.011Z",
    fill: "#908DC1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M233.549 281.011C233.549 281.011 223.5 329.796 224.009 346.551C224.009 346.551 237.666 342.722 247.198 346.551C247.198 346.551 230.977 344.743 223.993 352.179C217.008 359.616 238.504 379.156 281.513 375.187C281.513 375.187 290.091 377.874 294.446 376.297C294.446 376.297 293.28 384.07 281.439 383.865C269.647 383.396 235.152 383.109 217.28 367.628C217.288 367.636 215.036 322.787 233.549 281.011Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.1 290.363C254.1 290.363 257.066 311.965 261.857 316.485C266.647 321.004 288.973 319.525 297.815 324.398C297.815 324.398 306.139 309.977 321.192 300.955L300.781 333.092L283.139 328.926L261.602 325.639L259.794 329.797H256.557C256.557 329.797 256.195 306.739 254.1 290.363Z",
    fill: "#908DC1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M254.1 290.363C254.1 290.363 257.066 311.965 261.857 316.485C266.647 321.004 288.973 319.525 297.815 324.398C297.815 324.398 306.139 309.977 321.192 300.955L300.781 333.092L283.139 328.926L261.602 325.639L259.794 329.797H256.557C256.557 329.797 256.195 306.739 254.1 290.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.484 246.362C347.711 251.793 348.747 257.915 350.645 262.287C345.846 263.24 340.883 264.259 336.922 267.126C331.992 270.709 329.322 276.642 327.251 282.402C325.292 287.853 323.646 293.411 322.321 299.05C326.781 290.993 333.12 284.131 340.801 279.05C345.23 276.124 350.702 273.766 355.756 275.418C351.516 277.217 346.717 279.649 345.821 284.169C345.645 284.919 345.677 285.703 345.912 286.437C346.668 288.565 349.314 289.14 351.319 290.176C355.23 292.189 357.268 296.749 357.441 301.17C357.613 305.591 356.257 309.864 354.918 314.046C353.74 317.711 352.562 321.376 351.384 325.041C349.881 329.725 348.352 334.474 345.633 338.583C342.913 342.691 338.829 346.134 333.972 346.939C331.942 347.331 329.841 347.093 327.949 346.257C326.516 345.478 325.183 344.526 323.98 343.422C318.154 338.717 311.153 335.694 303.733 334.679C313.282 340.99 317.801 352.453 321.762 363.193C319.943 360.009 317.323 357.358 314.161 355.502C313.351 354.937 312.387 354.633 311.4 354.631C308.803 354.836 307.982 358.148 306.42 360.218C304.547 362.683 301.12 363.563 298.047 363.168C294.974 362.774 292.147 361.336 289.386 359.881L254.455 341.869L251.99 349.265C251.99 349.265 279.813 371.451 322.444 379.298C322.444 379.298 350.135 357.416 359.947 338.016C369.758 318.615 385.001 278.852 385.001 278.852C385.001 278.852 379.421 268.285 369.857 262.771C369.857 262.771 362.716 259.394 361.212 255.22C359.708 251.046 346.29 243.839 346.29 243.839C346.29 243.839 348.032 248.293 338.484 246.362Z",
    fill: "#908DC1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M338.484 246.362C347.711 251.793 348.747 257.915 350.645 262.287C345.846 263.24 340.883 264.259 336.922 267.126C331.992 270.709 329.322 276.642 327.251 282.402C325.292 287.853 323.646 293.411 322.321 299.05C326.781 290.993 333.12 284.131 340.801 279.05C345.23 276.124 350.702 273.766 355.756 275.418C351.516 277.217 346.717 279.649 345.821 284.169C345.645 284.919 345.677 285.703 345.912 286.437C346.668 288.565 349.314 289.14 351.319 290.176C355.23 292.189 357.268 296.749 357.441 301.17C357.613 305.591 356.257 309.864 354.918 314.046C353.74 317.711 352.562 321.376 351.384 325.041C349.881 329.725 348.352 334.474 345.633 338.583C342.913 342.691 338.829 346.134 333.972 346.939C331.942 347.331 329.841 347.093 327.949 346.257C326.516 345.478 325.183 344.526 323.98 343.422C318.154 338.717 311.153 335.694 303.733 334.679C313.282 340.99 317.801 352.453 321.762 363.193C319.943 360.009 317.323 357.358 314.161 355.502C313.351 354.937 312.387 354.633 311.4 354.631C308.803 354.836 307.982 358.148 306.42 360.218C304.547 362.683 301.12 363.563 298.047 363.168C294.974 362.774 292.147 361.336 289.386 359.881L254.455 341.869L251.99 349.265C251.99 349.265 279.813 371.451 322.444 379.298C322.444 379.298 350.135 357.416 359.947 338.016C369.758 318.615 385.001 278.852 385.001 278.852C385.001 278.852 379.421 268.285 369.857 262.771C369.857 262.771 362.716 259.394 361.212 255.22C359.708 251.046 346.29 243.839 346.29 243.839C346.29 243.839 348.032 248.293 338.484 246.362Z",
    fill: "#908DC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.549 170.722C335.549 170.722 337.415 148.971 328.039 146.892C318.663 144.813 313.396 136.21 313.396 136.21L280.133 145.495L274.973 165.495L278.26 175.619C278.26 175.619 278.95 185.011 279.081 189.654C279.213 194.296 279.081 197.871 282.598 203.508C286.115 209.145 289.385 214.741 296.986 219.613V232.424C296.986 232.424 292.286 246.138 294.883 254.553C294.883 254.553 296.436 256.196 300.725 253.731C305.014 251.266 323.363 239.006 329.764 226.203L331.753 193.655C331.753 193.655 337.037 194.477 339.313 189.662C342.657 184.954 342.526 179.465 341.227 174.994C339.929 170.524 334.341 173.417 334.341 173.417L335.549 170.722Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.346 202.611C298.286 201.587 299.445 200.788 300.737 200.273C302.029 199.758 303.42 199.54 304.807 199.637C304.807 199.637 308.809 193.318 313.024 194.476C313.024 194.476 314.322 201.173 309.269 203.811C302.695 207.237 297.346 202.611 297.346 202.611Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.989 142.727C284.989 142.727 277.027 153.188 277.487 164.092C277.947 174.996 279.533 182.728 279.073 191.143C278.613 199.557 287.487 213.649 296.584 219.327C303.379 223.575 311.9 222.852 318.515 218.505C325.91 213.575 329.978 204.717 331.465 196.212C331.613 195.391 331.728 194.569 331.81 193.682",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.581 219.334C296.581 219.334 297.871 231.117 296.581 235.152C295.159 239.581 293.442 249.893 294.937 254.552C296.433 259.212 324.412 239.63 329.819 226.195C329.819 226.195 330.567 200.089 332.432 193.565",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.812 202.323C295.812 202.323 308.54 205.922 313.749 192.783",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.837 222.17C296.837 222.17 299.549 230.576 305.399 231.077C311.25 231.579 325.884 219.853 330.872 206.04V199.129C330.872 199.129 326.764 217.207 314.734 220.494C302.704 223.781 297.075 219.598 297.075 219.598L296.837 222.17Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.015 194.476C307.362 194.082 304.798 199.637 304.798 199.637C303.405 199.467 301.991 199.65 300.687 200.17C299.383 200.69 298.231 201.529 297.337 202.611C298.73 203.861 300.442 204.699 302.283 205.032C304.124 205.366 306.022 205.182 307.764 204.501C314.19 202.266 313.015 194.476 313.015 194.476Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.843 169.694C298.913 172.301 298.798 174.91 298.498 177.501C298.194 179.826 297.117 182.053 296.222 184.239C295.4 186.227 294.028 189.284 295.17 191.379C296.468 193.754 300.782 191.379 300.782 191.379",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.437 190.885C304.891 191.082 306.953 190.885 307.364 188.363",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.136 166.555C309.542 165.214 311.41 164.466 313.354 164.466C315.297 164.466 317.165 165.214 318.571 166.555",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.553 168.609C291.553 168.609 287.7 163.679 282.654 168.609",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.786 181.074C328.786 181.074 333.182 170.515 338.918 172.783C342.87 174.353 343.109 181.173 341.013 185.931C338.918 190.688 337.866 195.536 330.881 192.825",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.565 179.457C329.565 179.457 325.342 177.961 324.561 171.1C323.781 164.239 327.988 157.369 326.426 152.439C324.865 147.508 312.564 149.974 309.762 141.378C309.762 141.378 300.526 148.264 282.646 146.785C282.646 146.785 278.874 153.211 278.217 157.139C277.336 163.28 277.358 169.517 278.282 175.652C278.282 175.866 278.356 176.071 278.397 176.285C279.679 182.974 273.295 167.18 273.467 160.434C273.64 153.688 269.572 145.117 274.872 138.733C280.172 132.348 299.606 128.609 303.435 125.61C307.264 122.611 314.709 130.598 323.312 133.539C331.916 136.481 339.048 139.99 337.963 152.192C336.879 164.395 338.021 166.03 338.07 172.456C338.07 172.472 334.093 170.977 329.565 179.457Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.371 175.447C313.371 177.09 312.738 178.454 311.949 178.454C311.161 178.454 310.536 177.107 310.536 175.447C310.536 173.787 311.169 172.447 311.949 172.447C312.73 172.447 313.371 173.803 313.371 175.447Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.554 175.447C291.554 177.09 290.922 178.454 290.141 178.454C289.36 178.454 288.728 177.107 288.728 175.447C288.728 173.787 289.36 172.447 290.141 172.447C290.922 172.447 291.554 173.803 291.554 175.447Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.136 179.457C308.136 179.457 311.069 182.571 314.783 183.015",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.151 183.015C288.151 183.015 293.517 182.637 294.725 179.457",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.626 256.55C304.619 254.011 309.903 254.965 314.275 256.764C316.674 257.758 318.958 259.007 321.35 260.051C322.532 260.574 323.751 261.008 324.998 261.349C327.997 262.13 326.921 258.408 326.748 256.739C326.502 254.348 326.329 251.949 326.042 249.574C325.923 249.082 325.982 248.565 326.206 248.111C326.501 247.746 326.913 247.493 327.373 247.397C332.64 245.753 338.318 246.476 343.807 246.575C344.305 246.634 344.81 246.539 345.253 246.304C346.075 245.77 345.984 244.562 345.763 243.609C343.864 235.49 337.168 227.413 329.887 223.353",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.043 224.669C293.42 226.18 289.697 227.75 286.575 230.067C285.442 230.893 284.398 231.835 283.46 232.877C282.705 233.596 282.23 234.56 282.121 235.597C282.141 236.08 282.269 236.551 282.495 236.978C282.721 237.404 283.04 237.775 283.428 238.062C283.979 238.516 284.587 238.897 285.235 239.196C286.747 239.911 288.522 240.61 289.163 242.13C289.319 242.448 289.376 242.806 289.328 243.157C289.246 243.465 289.088 243.748 288.867 243.979C287.618 245.499 285.416 246.674 285.581 248.638C285.687 250.158 287.224 251.103 288.588 251.777C289.952 252.451 291.546 253.149 292.015 254.603",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.59 147.616C276.124 144.329 279.559 142.209 282.862 141.675C286.165 141.141 289.559 141.675 292.887 141.387C295.67 141.112 298.362 140.243 300.78 138.838C303.199 137.433 305.288 135.526 306.905 133.244",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.327 138.377C285.293 134.852 293.674 138.517 299.492 134.753C301.138 133.555 302.572 132.088 303.732 130.415",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.426 273.23C334.062 277.495 326.091 293.214 326.091 293.214L300.782 333.076",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.364 268.924C339.137 267.281 341.145 265.913 343.322 264.864",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.426 299.015C322.426 299.015 325.121 284.619 332.862 274.01",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.559 329.73C256.559 329.73 255.45 285.629 251.629 278.891",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.796 243.592C345.796 243.592 358.122 250.987 363.595 257.939C369.067 264.89 382.001 269.508 384.959 278.892C384.959 278.892 367.925 332.567 350.078 351.967C332.23 371.368 322.402 379.33 322.402 379.33C322.402 379.33 279.468 371.869 251.62 348.483L261.579 325.599C261.579 325.599 289.657 329.148 300.758 333.093C311.86 337.037 322.402 360.924 322.402 360.924",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.782 333.091C300.782 333.091 320.438 336.912 326.822 345.86",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.339 342.294L343.32 433.963H257.493L254.567 382.41",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.454 376.305C289.713 386.018 283.46 383.873 283.46 383.873C235.102 385.706 217.287 367.636 217.287 367.636C217.287 367.636 214.822 342.221 224.33 307.923C233.837 273.624 251.643 243.591 251.643 243.591C259.54 238.34 277.157 234.24 282.129 233.155L283.46 232.876",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.485 383.872C283.485 383.872 280.929 383.453 281.578 366.51",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.949 349.567C252.949 349.567 240.87 345.31 225.906 355.664",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.619 345.86C228.619 345.86 244.445 341.152 251.627 348.695",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.918 348.268L251.972 349.295L259.795 329.755C259.795 329.755 251.693 328.432 238.857 344.414C242.865 344.461 246.749 345.814 249.918 348.268Z",
    fill: "#999999",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.555 366.51V375.195C281.555 375.195 292.623 378.482 300.816 373.757L281.555 366.51Z",
    fill: "#999999",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.548 246.483C341.556 246.644 341.539 246.805 341.498 246.96C341.153 248.316 332.714 280.174 305.704 294.348C305.47 294.474 305.207 294.539 304.94 294.537C304.573 294.537 304.217 294.414 303.927 294.187C303.638 293.961 303.434 293.644 303.346 293.287C303.258 292.931 303.292 292.555 303.442 292.22C303.593 291.885 303.851 291.61 304.176 291.439C328.827 278.514 337.513 249.055 338.269 246.344L341.548 246.483Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.425 238.037C279.155 247.789 276.852 258.288 276.646 268.933C276.646 269.796 276.646 270.675 276.646 271.571C276.646 271.793 276.646 272.014 276.646 272.236C276.401 272.245 276.157 272.269 275.915 272.31C275.026 272.451 274.164 272.728 273.359 273.132C273.359 271.924 273.359 270.749 273.359 269.59C273.713 251.151 279.218 238.604 282.152 233.18L283.483 232.901C282.727 233.62 282.253 234.584 282.143 235.621C282.168 236.093 282.295 236.553 282.517 236.971C282.738 237.388 283.048 237.752 283.425 238.037Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.787 286.935C317.71 289.606 316.132 294.043 312.254 296.845C308.375 299.647 303.675 299.746 301.744 297.075C299.813 294.405 301.391 289.967 305.269 287.165C309.148 284.363 313.889 284.265 315.787 286.935Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.003 285.352C312.367 287.242 311.249 290.381 308.538 292.361C305.826 294.341 302.465 294.415 301.142 292.525C299.819 290.635 300.896 287.496 303.607 285.516C306.319 283.536 309.639 283.47 311.003 285.352Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.286 318.704C288.936 318.937 288.51 319.026 288.096 318.955C287.681 318.883 287.311 318.656 287.059 318.319C286.808 317.982 286.695 317.562 286.743 317.144C286.792 316.727 286.999 316.344 287.322 316.074C287.461 315.959 292.975 311.267 290.559 295.466C290.354 294.127 290.091 292.697 289.738 291.193C288.694 286.402 287.083 280.338 283.788 275.885C283.004 274.71 281.931 273.757 280.672 273.118C279.412 272.479 278.009 272.175 276.598 272.236C276.353 272.245 276.109 272.269 275.867 272.31C274.978 272.45 274.116 272.728 273.312 273.132C270.857 274.4 268.994 276.575 268.118 279.196L267.823 280.018C265.959 285.057 264.436 290.215 263.262 295.458C261.947 301.908 261.504 308.671 263.837 313.396C264.463 314.692 265.353 315.843 266.452 316.773C267.55 317.703 268.832 318.391 270.214 318.794C270.585 318.916 270.9 319.166 271.104 319.5C271.307 319.833 271.385 320.228 271.324 320.614C271.262 320.999 271.066 321.35 270.769 321.604C270.472 321.858 270.095 321.998 269.704 321.999C269.531 321.999 269.359 321.971 269.195 321.917C267.398 321.377 265.732 320.471 264.304 319.254C262.875 318.038 261.715 316.538 260.896 314.85C258.266 309.534 258.611 302.294 259.942 295.458C261.122 289.835 262.721 284.309 264.725 278.925L265.021 278.103C265.666 276.147 266.749 274.364 268.185 272.888C269.621 271.412 271.374 270.281 273.312 269.582C273.982 269.35 274.672 269.179 275.374 269.073C275.793 269.015 276.196 268.974 276.623 268.949C278.546 268.896 280.452 269.327 282.166 270.201C283.881 271.075 285.348 272.365 286.434 273.954C290.099 278.884 291.841 285.4 292.95 290.511C293.337 292.269 293.632 293.921 293.854 295.482C296.451 313.198 289.606 318.474 289.286 318.704Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.554 321.712C268.554 321.712 274.511 324.177 276.023 321.712C277.535 319.247 276.311 318.088 274.248 317.891C272.193 317.786 270.133 317.786 268.077 317.891L268.554 321.712Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.29 320.889C271.182 321.219 270.974 321.506 270.693 321.709C270.413 321.913 270.075 322.023 269.729 322.023C269.556 322.023 269.384 321.995 269.219 321.941C267.422 321.401 265.757 320.495 264.328 319.278C262.9 318.062 261.739 316.562 260.92 314.874C258.29 309.558 258.636 302.318 259.967 295.482H263.254C261.939 301.932 261.495 308.695 263.829 313.42C264.454 314.716 265.345 315.867 266.443 316.797C267.542 317.727 268.823 318.415 270.205 318.818C270.413 318.882 270.606 318.986 270.774 319.125C270.941 319.264 271.079 319.435 271.18 319.627C271.281 319.82 271.343 320.03 271.361 320.247C271.38 320.464 271.356 320.682 271.29 320.889Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.797 316.922C283.55 317.216 283.367 317.559 283.261 317.928C283.155 318.298 283.127 318.686 283.181 319.067C283.345 319.629 283.702 320.117 284.188 320.444C284.674 320.771 285.26 320.918 285.843 320.858C287.011 320.703 288.078 320.116 288.835 319.214C289.656 318.294 292.508 312.271 289.87 313.306C287.955 314.029 285.079 315.254 283.797 316.922Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.284 318.703C288.934 318.936 288.508 319.026 288.094 318.954C287.68 318.882 287.309 318.655 287.057 318.318C286.806 317.981 286.693 317.561 286.742 317.144C286.79 316.726 286.997 316.343 287.32 316.074C287.46 315.959 292.973 311.267 290.557 295.465H293.844C296.449 313.198 289.604 318.473 289.284 318.703Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M304.028 173.466C304.028 173.466 314.373 168.092 323.88 173.466C323.88 173.466 324.036 181.395 320.446 184.657C319.172 185.816 313.338 186.013 311.127 185.816C302.154 185.002 304.028 173.466 304.028 173.466Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M297.536 173.466C297.536 173.466 287.19 168.092 277.691 173.466C277.691 173.466 277.535 181.395 281.118 184.657C282.392 185.816 288.234 186.013 290.436 185.816C299.409 185.002 297.536 173.466 297.536 173.466Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.028 173.466C304.028 173.466 314.373 168.092 323.88 173.466C323.88 173.466 324.036 181.395 320.446 184.657C319.172 185.816 313.338 186.013 311.127 185.816C302.154 185.002 304.028 173.466 304.028 173.466Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.536 173.466C297.536 173.466 287.19 168.092 277.691 173.466C277.691 173.466 277.535 181.395 281.118 184.657C282.392 185.816 288.234 186.013 290.436 185.816C299.409 185.002 297.536 173.466 297.536 173.466Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.534 173.466C297.534 173.466 299.851 171.765 304.026 173.466",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.88 173.464L328.202 175.469",
    stroke: "#263238",
    strokeMiterlimit: 10
  }))), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M147.249 201.666H23.1035V433.741H147.249V201.666Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M141.065 183.605H29.2688C22.5134 183.605 17.0371 189.082 17.0371 195.837V437.288C17.0371 444.043 22.5134 449.519 29.2688 449.519H141.065C147.82 449.519 153.296 444.043 153.296 437.288V195.837C153.296 189.082 147.82 183.605 141.065 183.605Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_120_9594",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 183,
    width: 137,
    height: 267
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M141.065 183.605H29.2688C22.5134 183.605 17.0371 189.082 17.0371 195.837V437.288C17.0371 444.043 22.5134 449.519 29.2688 449.519H141.065C147.82 449.519 153.296 444.043 153.296 437.288V195.837C153.296 189.082 147.82 183.605 141.065 183.605Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_120_9594)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M28.7637 183.606C25.6492 183.606 22.6623 184.843 20.46 187.045C18.2577 189.247 17.0205 192.234 17.0205 195.349V437.776C17.0189 439.494 17.3954 441.192 18.1234 442.748C18.8513 444.304 19.9128 445.681 21.2325 446.782L100.73 183.606H28.7637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8036 441.828C89.8036 440.912 89.5318 440.016 89.0227 439.254C88.5136 438.492 87.79 437.898 86.9434 437.548C86.0968 437.197 85.1652 437.105 84.2665 437.284C83.3677 437.463 82.5421 437.904 81.8942 438.552C81.2462 439.2 80.8049 440.026 80.6261 440.924C80.4474 441.823 80.5391 442.755 80.8898 443.601C81.2405 444.448 81.8343 445.172 82.5963 445.681C83.3582 446.19 84.254 446.462 85.1704 446.462C86.3992 446.462 87.5776 445.973 88.4465 445.105C89.3154 444.236 89.8036 443.057 89.8036 441.828Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M141.065 183.605H29.2688C22.5134 183.605 17.0371 189.082 17.0371 195.837V437.288C17.0371 444.043 22.5134 449.519 29.2688 449.519H141.065C147.82 449.519 153.296 444.043 153.296 437.288V195.837C153.296 189.082 147.82 183.605 141.065 183.605Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M147.249 201.666H23.1035V433.741H147.249V201.666Z",
    fill: "#ECEBFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_120_9594",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 172,
    width: 149,
    height: 262
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M160.284 172.541H12.3789V433.741H160.284V172.541Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_120_9594)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.03 362.758C116.03 362.758 112.221 413.798 110.671 423.017C109.122 432.237 107.661 437.393 107.877 443.819C108.093 450.245 110.024 468.697 106.163 479.644C102.302 490.591 102.353 503.875 102.734 507.735C103.115 511.596 104.448 516.739 104.233 517.603C104.017 518.466 97.8066 521.883 93.2983 522.746C90.4652 523.267 87.5937 523.551 84.7135 523.597C80.3506 525.138 75.8182 526.148 71.214 526.607C64.7754 527.038 55.9747 525.108 55.9747 525.108C55.9747 525.108 55.9747 509.234 55.1111 498.935C54.2476 488.635 51.3013 472.139 54.8952 459.693C58.4892 447.248 57.6891 440.644 57.4351 436.53C57.1811 432.415 57.4351 414.013 57.2192 413.366C57.0033 412.718 55.7207 359.114 55.7207 359.114C55.7207 359.114 79.0877 362.543 94.7461 361.044C110.404 359.546 114.481 359.546 114.481 359.546C114.481 359.546 117.961 355.685 116.03 362.758Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7934 520.6C85.7815 517.128 85.3552 513.671 84.5235 510.3C83.2535 506.021 83.0123 490.794 83.6599 484.571C84.3076 478.349 87.4698 462.703 87.4698 453.902C87.4698 445.101 88.3333 431.602 88.3333 431.602",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.177 426.878L105.744 426.662C104.677 426.662 104.677 410.368 104.677 410.368L130.177 426.878Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5036 365.768C78.5036 365.768 102.95 367.267 116.678 364.904L111.954 249.53C111.954 249.53 108.741 244.171 100.156 241.161C91.5714 238.151 81.2848 242.431 77.6401 246.52C73.9953 250.61 76.5733 365.336 76.5733 365.336L78.5036 365.768Z",
    fill: "#908DC1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5699 241.161C79.5699 241.161 55.3393 253.39 51.6946 255.537C48.0499 257.683 47.8848 265.391 47.8848 269.049C47.8848 272.706 48.9515 435.031 48.9515 435.031C58.1232 435.63 67.3304 434.69 76.1918 432.249C84.9309 429.963 93.1544 426.032 100.422 420.668L96.3458 333.384L91.774 256.819C91.774 256.819 89.0056 235.586 79.5699 241.161Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8597 233.224C86.8597 233.224 81.2847 233.872 78.9226 237.034C77.5384 238.9 76.5214 241.011 75.9255 243.257L73.7793 262.56L81.0688 260.845L77.424 269.417C77.424 269.417 81.0688 280.148 85.1453 289.152C89.2218 298.156 95.2287 316.596 95.2287 316.596L92.4348 258.915C92.4348 258.915 92.4348 242.19 91.1648 238.596C89.8949 235.002 88.5742 233.224 86.8597 233.224Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.804 245.022L105.096 419.804L130.178 426.878L126.533 293.711C126.533 293.711 127.181 259.423 125.034 254.673C122.888 249.924 103.598 240.31 101.667 240.564C99.737 240.818 100.804 245.022 100.804 245.022Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.803 236.234C102.365 236.615 103.825 237.329 105.084 238.329C106.342 239.329 107.369 240.59 108.093 242.025C110.239 246.736 115.814 261.328 115.814 261.328L108.74 262.179L116.246 267.538L102.949 317.51L101.451 263.423L100.181 241.123C100.181 241.123 98.6571 237.517 100.803 236.234Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1454 225.934C85.1454 225.934 86.009 232.157 84.7136 235.586C83.4183 239.015 88.7901 249.746 90.9363 256.388C93.0825 263.029 95.2287 268.401 96.5114 267.754C97.794 267.106 102.302 242.024 102.086 238.799C101.871 235.573 104.017 225.934 104.017 225.934C104.017 225.934 92.219 229.363 85.1454 225.934Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0831 219.394C76.8373 219.394 82.3127 213.674 82.3127 206.618C82.3127 199.563 76.8373 193.843 70.0831 193.843C63.3289 193.843 57.8535 199.563 57.8535 206.618C57.8535 213.674 63.3289 219.394 70.0831 219.394Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3568 212.626C76.3568 212.626 74.2106 207.051 71.6326 209.197C69.0546 211.343 71.6326 216.054 73.563 218.848C75.4933 221.642 79.138 220.347 78.7189 217.578C78.3724 215.751 77.5586 214.045 76.3568 212.626Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.554 209.158C109.554 209.158 110.633 203.799 112.094 207.444C112.74 208.872 113.038 210.432 112.963 211.998C112.888 213.563 112.442 215.088 111.662 216.448C110.392 218.594 110.595 218.378 110.163 216.448C109.826 214.031 109.622 211.597 109.554 209.158Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3477 202.301C73.3477 202.301 77.4242 222.023 80.0022 226.747C82.5801 231.472 91.1523 239.447 98.8735 236.183C106.595 232.919 110.887 226.963 110.887 219.674C110.887 212.384 111.954 203.164 110.671 195.215C110.024 191.595 108.161 188.304 105.39 185.886C102.619 183.469 99.1062 182.069 95.432 181.918C88.5616 181.702 77.8432 185.563 75.697 192.433C74.5844 195.635 73.7973 198.941 73.3477 202.301Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5632 209.59C73.5632 209.59 85.5769 204.866 93.2982 199.075C101.019 193.284 103.382 189.004 103.382 189.004C103.382 189.004 107.026 198.859 108.525 202.085C110.023 205.311 111.306 208.943 111.306 208.943C111.306 208.943 113.668 204.866 113.668 196.243C113.668 187.62 111.306 180.801 102.239 176.292C93.1712 171.784 78.4398 174.578 71.7599 181.017C65.08 187.455 66.4008 197.958 68.1152 202.034C69.457 204.863 71.3032 207.423 73.5632 209.59Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.156 201.653C100.156 201.653 98.8857 201.869 98.8857 205.729C98.8857 209.59 100.156 216.016 99.9525 216.879C99.7493 217.743 97.4126 220.308 95.8887 218.81",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5049 222.671C90.5049 222.671 96.0799 225.033 103.204 220.74",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.02 201.196C101.02 201.196 105.541 199.469 108.525 202.06",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5145 202.085C91.5518 201.502 89.4788 201.392 87.4655 201.765C85.4523 202.138 83.5561 202.984 81.9326 204.231",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5047 208.295C90.5047 209.565 89.984 210.657 89.3363 210.657C88.6887 210.657 88.1553 209.603 88.1553 208.295C88.1553 206.987 88.676 205.946 89.3363 205.946C89.9967 205.946 90.5047 207 90.5047 208.295Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.473 207.444C104.473 208.714 103.94 209.806 103.292 209.806C102.645 209.806 102.111 208.752 102.111 207.444C102.111 206.136 102.645 205.082 103.292 205.082C103.94 205.082 104.473 206.136 104.473 207.444Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.176 294.346L114.366 288.124C113.287 286.409 108.359 287.057 105.997 287.057C104.77 287.185 103.589 287.595 102.546 288.256C101.504 288.917 100.629 289.811 99.9905 290.867C99.1396 292.581 95.279 295.375 96.7775 297.089C98.2761 298.804 102.353 297.724 103 298.156C103.648 298.588 109.007 302.233 110.937 302.88C111.964 303.257 113.062 303.4 114.15 303.299L118.176 294.346Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.968 253.391C126.125 254.386 128.055 255.812 129.641 257.581C131.226 259.35 132.433 261.425 133.187 263.677C135.55 271.183 143.474 321.155 141.76 325.904C140.045 330.654 135.765 334.261 128.26 331.695C120.755 329.13 109.211 316.888 109.211 316.888L118.215 294.372L125.288 298.016L123.79 277.862",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.968 253.391C126.125 254.386 128.055 255.812 129.641 257.581C131.226 259.35 132.433 261.425 133.187 263.677C135.55 271.183 143.474 321.155 141.76 325.904C140.045 330.654 135.765 334.261 128.26 331.695C120.755 329.13 109.211 316.888 109.211 316.888L118.215 294.372L125.288 298.016L123.79 277.862",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.25 297.991C125.25 297.991 136.616 304.646 137.695 307.008",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.874 267.97H69.4863V325.879H110.874V267.97Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1546 308.29C88.1546 308.29 96.079 303.998 98.4411 301.636C100.803 299.274 101.235 299.096 102.518 299.096C105.674 299.095 108.827 298.879 111.953 298.448C113.223 298.016 112.601 300.988 111.953 301.661C111.306 302.334 107.242 303.172 107.242 303.172C107.242 303.172 114.1 302.525 114.315 304.671C114.469 305.286 114.449 305.932 114.259 306.537C114.068 307.142 113.714 307.683 113.236 308.1L112.601 308.747C112.601 308.747 113.236 313.243 112.601 315.389C111.966 317.535 110.671 318.183 107.877 318.602C104.148 318.84 100.404 318.627 96.7267 317.967C94.5805 317.535 87.291 319.034 87.291 319.034L88.1546 308.29Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.632 251.676C59.632 251.676 46.9326 254.457 44.8244 255.74C42.7163 257.022 35.6046 308.074 34.1061 316.697C32.6076 325.32 47.4024 326.996 51.8853 328.711C56.3682 330.425 89.2344 332.952 89.2344 332.952L89.6662 306.36L66.9342 300.569L66.7183 263.893",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.632 251.676C59.632 251.676 46.9326 254.457 44.8244 255.74C42.7163 257.022 35.6046 308.074 34.1061 316.697C32.6076 325.32 47.4024 326.996 51.8853 328.711C56.3682 330.425 89.2344 332.952 89.2344 332.952L89.6662 306.36L66.9342 300.569L66.7183 263.893",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9214 300.569C66.9214 300.569 58.9842 296.924 53.841 298.855C48.6977 300.785 44.4053 310.652 44.4053 310.652",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1207 297.991C58.1207 297.991 50.6154 297.559 46.9706 299.071C44.7288 300.019 42.7441 301.486 41.1797 303.35",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8729 266.039H84.2939V270.763H98.8729V266.039Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M551.579 61.9248C552.432 57.0281 553.682 44.8673 546.285 38.8972C536.889 31.3095 530.213 44.9555 522.037 34.3387C513.861 23.7219 511.42 0.694276 487.172 1.00308C462.924 1.31187 461.101 14.9432 461.101 19.4869C461.101 24.0307 453.822 27.3687 452.278 27.3687C450.734 27.3687 442.279 23.4278 439.249 32.2212C436.22 41.0147 438.264 46.1025 433.456 46.279C428.647 46.4554 422.648 39.8971 416.089 43.191C409.531 46.4848 409.531 53.4843 406.811 55.8664C404.09 58.2486 399.532 54.0431 393.474 56.4693C392.216 56.8422 391.081 57.5446 390.186 58.5039C389.292 59.4631 388.67 60.6443 388.386 61.9248H551.579Z",
    fill: "white",
    stroke: "#514C9F",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M416.134 56.5281C422.692 53.249 428.677 59.822 433.5 59.6308C438.323 59.4397 436.265 54.3666 439.294 45.5731C442.323 36.7797 450.807 40.7206 452.322 40.7206C453.837 40.7206 461.145 37.3826 461.145 32.8388C461.145 28.2951 462.968 14.6491 487.216 14.3403C511.465 14.0315 513.847 37.0738 522.008 47.6906C530.169 58.3074 536.86 44.6614 546.256 52.2344C549.08 54.6674 550.964 58.0127 551.579 61.6895C552.447 56.6458 553.549 44.7644 546.256 38.8972C536.86 31.3095 530.184 44.9555 522.008 34.3387C513.832 23.7219 511.391 0.694276 487.143 1.00308C462.895 1.31187 461.071 14.9432 461.071 19.4869C461.071 24.0307 453.793 27.3687 452.249 27.3687C450.705 27.3687 442.249 23.4278 439.22 32.2212C436.191 41.0147 438.235 46.1025 433.427 46.279C428.618 46.4554 422.619 39.8971 416.06 43.191C409.502 46.4848 409.502 53.4843 406.782 55.8664C404.061 58.2486 399.503 54.0431 393.444 56.4693C392.187 56.8422 391.052 57.5446 390.157 58.5039C389.262 59.4631 388.641 60.6443 388.356 61.9248H410.693C411.903 59.6053 413.804 57.7194 416.134 56.5281Z",
    fill: "#908DC1",
    stroke: "#514C9F",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M179.755 119.346C180.358 115.905 181.226 107.362 176.05 103.171C169.447 97.8479 164.757 107.421 159.007 99.9653C153.257 92.51 151.552 76.3348 134.524 76.5407C117.496 76.7466 116.157 86.3488 116.157 89.4809C116.157 92.613 111.04 95.0099 109.981 95.0099C108.923 95.0099 102.953 92.2454 100.82 98.4214C98.6882 104.597 100.129 108.171 96.7472 108.303C93.3651 108.435 89.1595 103.892 84.557 106.127C79.9544 108.362 79.9544 113.332 78.0428 114.949C76.1312 116.567 72.9255 113.685 68.6758 115.376C67.7926 115.643 66.9956 116.138 66.3655 116.812C65.7354 117.486 65.2947 118.315 65.0879 119.214L179.755 119.346Z",
    fill: "white",
    stroke: "#514C9F",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6158 115.552C89.2184 113.244 93.4386 117.861 96.806 117.729C100.173 117.596 98.747 114.023 100.879 107.847C103.011 101.671 108.967 104.45 110.04 104.45C111.114 104.45 116.216 102.098 116.216 98.9066C116.216 95.7157 117.481 86.1282 134.524 85.9223C151.566 85.7165 153.257 101.892 159.007 109.347C164.757 116.802 169.447 107.215 176.05 112.538C178.025 114.25 179.345 116.594 179.785 119.17C180.388 115.626 181.167 107.288 176.05 103.171C169.447 97.8479 164.757 107.421 159.007 99.9653C153.257 92.51 151.552 76.3348 134.524 76.5407C117.496 76.7466 116.157 86.3488 116.157 89.4809C116.157 92.613 111.04 95.0099 109.981 95.0099C108.923 95.0099 102.953 92.2454 100.82 98.4214C98.6882 104.597 100.129 108.171 96.7472 108.303C93.3651 108.435 89.1595 103.892 84.557 106.127C79.9544 108.362 79.9544 113.332 78.0428 114.949C76.1312 116.567 72.9255 113.685 68.6758 115.376C67.7926 115.643 66.9956 116.138 66.3655 116.812C65.7354 117.486 65.2947 118.315 65.0879 119.214H80.8661C81.7094 117.637 83.0189 116.358 84.6158 115.552Z",
    fill: "#908DC1",
    stroke: "#514C9F",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M294.467 41.4998C294.937 38.8382 295.614 32.2358 291.599 29.0008C286.497 24.8981 282.879 32.2946 278.453 26.5304C274.027 20.7661 272.689 8.2965 259.543 8.45825C246.397 8.62001 245.412 15.9577 245.412 18.4869C245.412 21.0161 241.456 22.7513 240.633 22.7513C239.809 22.7513 235.207 20.6191 233.574 25.3834C231.942 30.1477 233.045 32.9122 230.428 33.0152C227.81 33.1181 224.546 29.5448 221.017 31.3241C217.487 33.1034 217.458 36.8972 215.973 38.2059C214.488 39.5147 212.032 37.2207 208.753 38.5441C208.072 38.7438 207.457 39.1217 206.971 39.6387C206.485 40.1557 206.146 40.7931 205.988 41.4851L294.467 41.4998Z",
    fill: "white",
    stroke: "#514C9F",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M221.017 38.5735C224.575 36.7796 227.81 40.3528 230.428 40.2499C233.045 40.147 231.898 37.3972 233.574 32.6181C235.251 27.8391 239.809 29.986 240.633 29.986C241.456 29.986 245.412 28.192 245.412 25.7216C245.412 23.2512 246.397 15.8547 259.543 15.693C272.689 15.5312 274.012 28.0156 278.453 33.7798C282.894 39.5441 286.497 32.1329 291.599 36.2355C293.153 37.5464 294.195 39.3638 294.54 41.3674C295.011 38.6324 295.614 32.1917 291.599 29.0008C286.497 24.8981 282.879 32.2946 278.453 26.5304C274.027 20.7661 272.689 8.2965 259.543 8.45825C246.397 8.62001 245.412 15.9577 245.412 18.4869C245.412 21.0161 241.456 22.7513 240.633 22.7513C239.809 22.7513 235.207 20.6191 233.574 25.3834C231.942 30.1477 233.045 32.9122 230.428 33.0152C227.81 33.1181 224.546 29.5448 221.017 31.3241C217.487 33.1034 217.458 36.8972 215.973 38.2059C214.488 39.5147 212.032 37.2207 208.753 38.5441C208.072 38.7438 207.457 39.1217 206.971 39.6387C206.485 40.1557 206.146 40.7931 205.988 41.4851H218.076C218.721 40.2263 219.751 39.2064 221.017 38.5735Z",
    fill: "#908DC1",
    stroke: "#514C9F",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M593.077 121.538C593.371 119.921 593.783 115.906 591.342 113.951C588.239 111.451 586.048 115.95 583.357 112.48C580.666 109.01 579.857 101.407 571.873 101.496C563.888 101.584 563.3 106.098 563.3 107.583C563.3 109.069 560.903 110.186 560.359 110.186C559.815 110.186 557.065 108.892 556.065 111.774C555.065 114.656 555.742 116.347 554.154 116.406C552.565 116.465 550.595 114.304 548.448 115.392C546.301 116.48 546.286 118.774 545.389 119.568C544.493 120.362 542.993 118.965 540.978 119.759C540.564 119.886 540.191 120.12 539.896 120.438C539.602 120.755 539.397 121.145 539.302 121.568L593.077 121.538Z",
    fill: "white",
    stroke: "#514C9F",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M548.476 119.758C550.623 118.67 552.594 120.832 554.182 120.773C555.77 120.714 555.094 119.038 556.093 116.141C557.093 113.244 559.887 114.553 560.387 114.553C560.887 114.553 563.328 113.45 563.328 111.95C563.328 110.45 563.916 105.965 571.901 105.863C579.886 105.76 580.724 113.347 583.385 116.847C586.047 120.347 588.267 115.847 591.37 118.317C592.296 119.117 592.915 120.214 593.12 121.42C593.399 119.758 593.767 115.847 591.37 113.921C588.267 111.421 586.076 115.921 583.385 112.45C580.694 108.98 579.886 101.378 571.901 101.466C563.916 101.554 563.328 106.068 563.328 107.554C563.328 109.039 560.931 110.156 560.387 110.156C559.843 110.156 557.093 108.862 556.093 111.744C555.094 114.627 555.77 116.318 554.182 116.376C552.594 116.435 550.623 114.274 548.476 115.362C546.33 116.45 546.315 118.744 545.418 119.538C544.521 120.332 543.021 118.935 541.006 119.729C540.592 119.856 540.219 120.09 539.925 120.408C539.63 120.725 539.425 121.115 539.33 121.538H546.682C547.074 120.768 547.703 120.144 548.476 119.758Z",
    fill: "#908DC1",
    stroke: "#514C9F",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M501.422 36.4561C501.892 33.7946 502.569 27.1921 498.554 23.9571C493.452 19.8398 489.834 27.2362 485.408 21.4867C480.982 15.7371 479.644 3.23811 466.498 3.41457C453.352 3.59103 452.367 10.9728 452.367 13.4285C452.367 15.8842 448.411 17.7076 447.588 17.7076C446.764 17.7076 442.162 15.5754 440.529 20.3397C438.897 25.1041 440 27.8685 437.383 27.9715C434.765 28.0744 431.501 24.5012 427.972 26.2804C424.442 28.0597 424.413 31.8535 422.928 33.1622C421.443 34.471 418.987 32.177 415.708 33.4858C415.027 33.6854 414.412 34.0633 413.926 34.5803C413.44 35.0974 413.101 35.7348 412.943 36.4267L501.422 36.4561Z",
    fill: "white",
    stroke: "#514C9F",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M427.897 33.5152C431.456 31.7359 434.691 35.3091 437.308 35.2062C439.926 35.1033 438.779 32.2653 440.455 27.5745C442.132 22.8836 446.69 24.9423 447.513 24.9423C448.337 24.9423 452.293 23.1336 452.293 20.6779C452.293 18.2222 453.278 10.811 466.424 10.6493C479.57 10.4875 480.893 22.9719 485.334 28.7214C489.775 34.471 493.378 27.0892 498.48 31.1918C500.028 32.5014 501.069 34.312 501.421 36.3091C501.892 33.574 502.495 27.148 498.48 23.9571C493.378 19.8398 489.76 27.2362 485.334 21.4867C480.908 15.7371 479.57 3.23811 466.424 3.41457C453.278 3.59103 452.293 10.9728 452.293 13.4285C452.293 15.8842 448.337 17.7076 447.513 17.7076C446.69 17.7076 442.087 15.5754 440.455 20.3397C438.823 25.1041 439.926 27.8685 437.308 27.9715C434.691 28.0744 431.427 24.5012 427.897 26.2804C424.368 28.0597 424.339 31.8535 422.854 33.1622C421.368 34.471 418.913 32.177 415.634 33.4858C414.953 33.6854 414.338 34.0633 413.852 34.5803C413.366 35.0974 413.026 35.7348 412.869 36.4267H424.956C425.607 35.1716 426.636 34.153 427.897 33.5152Z",
    fill: "#908DC1",
    stroke: "#514C9F",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M474.122 376.571H457.462V448.918H474.122V376.571Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M340.047 376.338H323.387V448.685H340.047V376.338Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M477.827 376.571H461.167V448.918H477.827V376.571Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M343.752 376.338H327.092V448.685H343.752V376.338Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M529.059 376.571H512.398V448.918H529.059V376.571Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M401.984 376.338H385.323V448.685H401.984V376.338Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M571.645 412.42H534.001V448.917H571.645V412.42Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M444.57 412.187H406.926V448.685H444.57V412.187Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M567.631 412.42H548.809V448.917H567.631V412.42Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M440.555 412.187H421.733V448.685H440.555V412.187Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M624.096 412.42H589.54V448.917H624.096V412.42Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M497.021 412.187H462.465V448.685H497.021V412.187Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M637.698 394.496H605.598V448.918H637.698V394.496Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M510.623 394.263H478.522V448.686H510.623V394.263Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M519.255 441.377H487.154V448.671H519.255V441.377Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M519.255 428.776H487.154V436.069H519.255V428.776Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M519.255 416.159H487.154V423.452H519.255V416.159Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M519.255 403.557H487.154V410.85H519.255V403.557Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M535.221 376.571H520.722V448.918H535.221V376.571Z",
    fill: "#908DC1",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M408.146 376.338H393.647V448.685H408.146V376.338Z",
    fill: "#908DC1",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M511.164 352.014H480.299V448.919H511.164V352.014Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M312.09 351.782H281.225V448.686H312.09V351.782Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M511.164 352.014H495.121V448.919H511.164V352.014Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M312.089 351.782H296.046V448.686H312.089V351.782Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M488.327 418.391H471.667V448.918H488.327V418.391Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M361.252 418.158H344.592V448.685H361.252V418.158Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M494.18 418.391H477.52V448.918H494.18V418.391Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M367.106 418.158H350.445V448.685H367.106V418.158Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M497.577 359.322H484.622V362.645H497.577V359.322Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M298.502 359.089H285.547V362.413H298.502V359.089Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M497.577 367.278H484.622V370.601H497.577V367.278Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M298.502 367.045H285.547V370.369H298.502V367.045Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M497.577 375.247H484.622V378.57H497.577V375.247Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M298.502 375.015H285.547V378.338H298.502V375.015Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M497.577 383.217H484.622V386.54H497.577V383.217Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M298.502 382.984H285.547V386.307H298.502V382.984Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M497.577 391.172H484.622V394.496H497.577V391.172Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M298.502 390.94H285.547V394.263H298.502V390.94Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M497.577 399.143H484.622V402.466H497.577V399.143Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M298.502 398.91H285.547V402.233H298.502V398.91Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M497.577 407.098H484.622V410.421H497.577V407.098Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M298.502 406.865H285.547V410.188H298.502V406.865Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M599.422 375.247H568.557V448.918H599.422V375.247Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M472.347 375.015H441.481V448.685H472.347V375.015Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M599.422 375.247H583.379V448.918H599.422V375.247Z",
    fill: "#908DC1",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M472.347 375.015H456.304V448.685H472.347V375.015Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M573.498 376.571V446.257",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M446.423 376.338V446.024",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M578.438 376.571V446.257",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M451.363 376.338V446.024",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M209.07 448.918H225.73V376.57H209.07V448.918Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M260.89 448.917H277.551V376.57H260.89V448.917Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M205.379 448.918H222.039V376.57H205.379V448.918Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M257.198 448.917H273.858V376.57H257.198V448.917Z",
    fill: "#908DC1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M154.148 448.918H170.809V376.57H154.148V448.918Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M211.967 448.918H228.628V376.57H211.967V448.918Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M111.563 448.903H149.207V412.406H111.563V448.903Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M115.563 448.903H134.385V412.406H115.563V448.903Z",
    fill: "#908DC1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M158.736 448.918H196.38V395.686H158.736V448.918Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M216.555 448.918H254.199V395.686H216.555V448.918Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M162.749 448.918H181.571V395.686H162.749V448.918Z",
    fill: "#908DC1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M220.57 448.918H239.392V395.686H220.57V448.918Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1109 448.903H93.667V412.406H59.1109L59.1109 448.903Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5089 448.918H77.6094V394.495H45.5089L45.5089 448.918Z",
    fill: "#908DC1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8771 448.918H68.9775V441.624H36.8771V448.918Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8771 436.301H68.9775V429.008H36.8771V436.301Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8771 423.699H68.9775V416.406H36.8771V423.699Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8771 411.083H68.9775V403.789H36.8771V411.083Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M147.986 448.918H162.484V376.57H147.986V448.918Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M205.806 448.918H220.305V376.57H205.806V448.918Z",
    fill: "#908DC1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M194.895 448.918H211.556V418.391H194.895V448.918Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M252.715 448.918H269.375V418.391H252.715V448.918Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M189.028 448.918H205.688V418.391H189.028V448.918Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M246.847 448.918H263.508V418.391H246.847V448.918Z",
    fill: "#908DC1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4678 448.918H44.333L44.333 352.013H13.4678L13.4678 448.918Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0402 362.631H39.9951V359.308H27.0402V362.631Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0402 370.6H39.9951V367.277H27.0402V370.6Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0402 378.57H39.9951V375.247H27.0402V378.57Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0402 386.525H39.9951V383.202H27.0402V386.525Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0402 394.496H39.9951V391.173H27.0402V394.496Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0402 402.451H39.9951V399.127H27.0402V402.451Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9322 409.95H114.651L114.651 336.28H96.9322L96.9322 409.95Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9315 409.95H106.151L106.151 336.28H96.9315L96.9315 409.95Z",
    fill: "#908DC1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M111.812 337.603V407.289",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M108.975 337.603V407.289",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7861 448.918H114.651L114.651 375.247H83.7861L83.7861 448.918Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7853 448.918H99.8281L99.8281 375.247H83.7853L83.7853 448.918Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M109.71 376.571V446.257",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M104.769 376.571V446.257",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5235 394.496L29.9512 429.096V448.242H45.5235V394.496Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M0 449.551H642.886",
    stroke: "#263238",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscoverability);
export default __webpack_public_path__ + "static/media/discoverability.fe75eb94dbadf8ee163c22de35e2359c.svg";
export { ForwardRef as ReactComponent };